export default __webpack_public_path__ + "static/media/eva.51e2a67d.svg";